import React from "react";
// NAVIGATION
import { useNavigate, useLocation } from "react-router-dom";
// ANT DESIGN COMPONENTS
import { Breadcrumb } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";

function BanksBreadcrumb() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const location = useLocation();
  const idServer = new URLSearchParams(location.search).get("idServer");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onClickServer = () => {
    navigate({
      pathname: "/edge-management/servers",
    });
  };

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Breadcrumb className="">
      <Breadcrumb.Item>{t("header.edgeManagement")}</Breadcrumb.Item>
      {idServer && idServer !== "" && (
        <Breadcrumb.Item className="generalStyles__breadcrumbItemInactive" onClick={onClickServer}>
          {t("header.servers")}
        </Breadcrumb.Item>
      )}
      <Breadcrumb.Item className="generalStyles__breadcrumbItem">
        {t("header.banks")}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
}

export default BanksBreadcrumb;
